import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const CustomerAuthContext = createContext(null);
const CUSTOMER_TOKEN_KEY = 'customer_token';

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    // temporarily set token in axios for /me check
    api.get('/customers/me', { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setCustomer(res.data))
      .catch(() => localStorage.removeItem(CUSTOMER_TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const register = async (data) => {
    const res = await api.post('/customers/register', data);
    localStorage.setItem(CUSTOMER_TOKEN_KEY, res.data.access_token);
    const me = await api.get('/customers/me', { headers: { Authorization: `Bearer ${res.data.access_token}` } });
    setCustomer(me.data);
    return me.data;
  };

  const login = async (email, password) => {
    const res = await api.post('/customers/login', { email, password });
    localStorage.setItem(CUSTOMER_TOKEN_KEY, res.data.access_token);
    const me = await api.get('/customers/me', { headers: { Authorization: `Bearer ${res.data.access_token}` } });
    setCustomer(me.data);
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem(CUSTOMER_TOKEN_KEY);
    // Clear cart on logout to prevent cross-account leakage on shared devices
    try {
      localStorage.removeItem('betti_cart_v1');
    } catch (e) {
      console.warn('[customer-auth] localStorage removeItem failed:', e);
    }
    window.dispatchEvent(new CustomEvent('customer:logout'));
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, login, register, logout, loading }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
